<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <h5>تمام بازیکن ها {{ allPlayers }}</h5>
              <h5>تمام بازی ها {{ allGames }}</h5>
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام کاربری</th>
                    <th>شماره همراه</th>
                    <th>امتیاز</th>
                    <th>برد</th>
                    <th>باخت</th>
                    <th>گل زده</th>
                    <th>گل خورده</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="player in topThen" :key="player._id">
                    <td>
                      <router-link :to="{ path: '/dashboard/user', query: { id: player.player._id } }">{{
                        player.player.username
                      }}</router-link>
                    </td>
                    <td>{{ player.player.phone }}</td>
                    <td>{{ player.score }}</td>
                    <td>{{ player.wins }}</td>
                    <td>{{ player.looses }}</td>
                    <td>{{ player.goals }}</td>
                    <td>{{ player.receivedGoals }}</td>
                    <td>
                      <button @click="showChangeUserScoreModal(player)">تغییر امتیاز</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row" style="padding:9px 10px">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_info" id="sorting-table_info" role="status" aria-live="polite">
                    {{ `صفحه ${page.current} از ${page.total} - تعداد کل: ${page.count} ` }}
                  </div>
                </div>
                <div class="col-sm-12 col-md-6" style="direction:ltr">
                  <div class="dataTables_paginate paging_simple_numbers" id="sorting-table_paginate">
                    <ul class="pagination">
                      <!-- disabled -->
                      <li class="paginate_button page-item previous" id="sorting-table_previous">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="0"
                          tabindex="0"
                          class="page-link"
                          @click="getLeagues({ page: page.pre })"
                          >قبلی</a
                        >
                      </li>
                      <li class="paginate_button page-item">
                        <a aria-controls="sorting-table" data-dt-idx="1" tabindex="0" class="page-link">{{
                          page.current
                        }}</a>
                      </li>
                      <li class="paginate_button page-item next" id="sorting-table_next">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="3"
                          tabindex="0"
                          class="page-link"
                          @click="getLeagues({ page: page.next })"
                          >بعدی</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->

    <div id="ChangeUserScoreModal" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">بنر</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <div class="row d-flex align-items-center mb-5">
                <div class="col-lg-12 mt-2">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="number" v-model="selectedUser.addScore" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>امتیاز</label>
                    </div>
                  </div>
                </div>
                <div>
                  امتیاز فعالی کاربر‌: {{ selectedUser.player.score }} امتیاز بعد اط اعمال:
                  {{ parseInt(selectedUser.player.score) + parseInt(selectedUser.addScore) }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button @click="hideModal" type="button" class="btn btn-info ml-4">
                انصراف
              </button>
              <button type="submit" class="btn btn-primary ml-auto" @click="changeUserScore">
                ذخیره
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leagueService from '../../../../services/league';
export default {
  name: 'league',
  data() {
    return {
      topThen: [],
      allPlayers: '',
      allGames: '',
      page: {
        next: '',
        pre: '',
        current: '',
        total: '',
        count: '',
      },
      selectedUser: {
        player: {},
        addScore: 0,
      },
    };
  },
  created() {
    this.getLeagues({});
  },
  methods: {
    async getLeagues({ page = 1 }) {
      try {
        const leagueReport = await leagueService.leagueReport({ id: this.$route.query.id, page });
        this.topThen = leagueReport.topThen;
        this.allPlayers = leagueReport.allPlayers;
        this.allGames = leagueReport.allGames;
        this.pageController(leagueReport);
      } catch (err) {
        console.log(err);
      }
    },

    pageController(res) {
      this.page.count = res.count;
      this.page.current = res.currentPage;
      this.page.total = res.totalPages;
      if (this.page.current == this.page.total) {
        this.page.next = '';
      } else {
        this.page.next = parseInt(this.page.current) + 1;
      }
      if (this.page.current == 1) {
        this.page.pre = '';
      } else {
        this.page.pre = this.page.current - 1;
      }
    },
    async changeUserScore() {
      try {
        await leagueService.changeUserScore({
          leagueId: this.$route.query.id,
          user: this.selectedUser.player.player._id,
          addScore: this.selectedUser.addScore,
        });
        window.notif({ isError: false, mssg: 'امتیاز کاربر تغییر پیدا کرد' });
        window.$('#ChangeUserScoreModal').modal('hide');

        await this.getLeagues({ page: parseInt(this.page.current) });
      } catch (err) {
        console.log(err);
      }
    },
    showChangeUserScoreModal(player) {
      this.selectedUser = { player, addScore: 0 };
      console.log(this.selectedUser);
      window.$('#ChangeUserScoreModal').modal('show');
    },
    hideModal() {
      this.selectedUser = { player: {}, addScore: 0 };
      window.$('#ChangeUserScoreModal').modal('hide');
    },
    status(league) {
      const startDate = new Date(league.startDate);
      const endDate = new Date(league.endDate);
      const now = new Date();
      if (endDate < now) return 'برگذار شده';
      if (startDate < now && endDate > now && league.isAvailable == true) return 'در حال برگذازی';
      if (startDate > now && league.isAvailable) return 'برگذار نشده - فعال';
      return 'برگذار نشده - غیر فعال';
    },
  },
};
</script>
